import PersListTimeEvent from "./subElements/persListTimeEvent";
import './mainListTimeEvent.css'
const ListTimeEvent = ({ Events, ticket }) => {
    return <PersListTimeEvent
        
        ticket={ticket}
    />
}

export default ListTimeEvent